export const TestStatusEnum = {
  NOT_STARTED: 'NOT_STARTED',
  RECORDING: 'RECORDING',
  FINISHED: 'FINISHED',
  WAITING_FOR_SCORING: 'WAITING_FOR_SCORING',
  SCORING_IN_PROGRESS: 'SCORING_IN_PROGRESS',
  READY_FOR_CLINICAL_REVIEW: 'READY_FOR_CLINICAL_REVIEW',
  TEST_COMPLETED: 'TEST_COMPLETED',
};

export enum TestRoomStatusEnum {
  AVAILABLE = 'AVAILABLE',
  OCCUPIED = 'OCCUPIED',
  OUT_OF_SERVICE = 'OUT_OF_SERVICE',
}

export const REPORT_READY_STATUSES =  [TestStatusEnum.READY_FOR_CLINICAL_REVIEW, TestStatusEnum.TEST_COMPLETED]
export const REPORT_SCHEDULED_STATUSES =  [TestStatusEnum.NOT_STARTED]

export type TTestStatusEnum = keyof typeof TestStatusEnum;


export const AnnotationDrawTypeEnum = {
  ALL: 'ALL',
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL',
}

export type TAnnotationDrawTypeEnumEnum = keyof typeof AnnotationDrawTypeEnum;
